import { getRgObjectsOfType as i, RG_TYPE as s } from "@project-rouge/rg-core";
const d = (l, o) => {
  let t = 0;
  const f = i(l, s.Building);
  for (const n of f) {
    const r = n.data.levels.filter((e) => e.levelIndex === o).map((e) => e.floorWorldBottom);
    t = Math.max(t, ...r);
  }
  return t;
};
export {
  d as getLevelFfl
};
//# sourceMappingURL=index18.js.map
